import React, {useEffect, useState }  from 'react'

import DrawerInsideComponent from '../../DrawerInside/DrawerInside'

import * as Components from '../../index'


interface AlertsDrawerProps{
    visible: boolean,
    setShowDrawer: any
}


const AlertsDrawerComponent = (props : AlertsDrawerProps): JSX.Element => {

    const [showDrawer, setShowDrawer] = useState<boolean>(false);

    useEffect(()=>{
        setShowDrawer(props.visible);
    }, [props.visible])

    return(
    <DrawerInsideComponent 
        mobilefixed={showDrawer} 
        showadd={showDrawer} 
        donclose={()=>{ props.setShowDrawer(false); }} 
        dtitle=""
        dwidth={"35%"}
    >
        <Components.Alerts />
    </DrawerInsideComponent>)
}

export default AlertsDrawerComponent;